// extracted by mini-css-extract-plugin
export default {"root":"navy-modal_root__7eFHh","noLongPress":"navy-modal_noLongPress__Q1JnF"};